import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { IJobBase } from '@/types'
import { Badge } from '@components-v2/atoms/Badge'
import styles from './index.module.scss'

type Props = {
  job: IJobBase
}

export const JobItemContentLabel: FC<Props> = ({ job }) => {
  const { t } = useTranslation('jobs')

  const items = [t(job?.primaryJobCategory?.name)].filter(Boolean)

  return (
    <div className={styles.container}>
      {items.map((item) => (
        <Badge key={item} color='primary'>
          {item}
        </Badge>
      ))}
    </div>
  )
}
